import { createSelector } from "reselect";
import getUser from "../base_getters/get_user";
import { FirebaseUser } from "avvir";

const getFirebaseUser = createSelector([
  getUser
], (user) => ((user as FirebaseUser)?.firebaseUser) || null);

export default getFirebaseUser;
